import { render, staticRenderFns } from "./ModalEditProductCategories.vue?vue&type=template&id=96895d18&"
import script from "./ModalEditProductCategories.vue?vue&type=script&lang=js&"
export * from "./ModalEditProductCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports